"use client";
import { visit as t } from "unist-util-visit";
function l() {
  return (r) => {
    t(r, "element", (e, n, i) => {
      e.tagName === "code" && (i && i.tagName === "pre" ? e.properties.inline = !1 : e.properties.inline = !0);
    });
  };
}
export {
  l as rehypeInlineCodeProperty
};
